import React from "react";
import Layout from "../../../../layout/Layout";
import { Box, Grid } from "@mui/material";
import ProfileLeftPanel from "../../../../components/Profile/MyProfile/ProfileLeftPanel";
import EmailConfirmationAlert from "../../../../components/Common/EmailConfirmationAlert";
import ProfileBox from "../../../../components/Profile/MyProfile/ProfileBox";
import { useSelector } from "react-redux";

const MyProfile = () => {
  const { userData } = useSelector((state) => state.user);
  return (
    <Layout heading={"Profile"} btnText={"Edit Profile"}>
      <Box sx={{ height: "100%" }}>
        <Grid container spacing={2}>
          <Grid item size={{ xs: 12, sm: 3 }}>
            <ProfileLeftPanel user={userData} />
          </Grid>
          <Grid item size={{ xs: 12, sm: 9 }}>
            <EmailConfirmationAlert />
            <ProfileBox user={userData} />
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
};

export default MyProfile;
